/* CT Parts Counter -- PDP renderer + 404 router.
   Working model 2026-08-07 · warranty gate 8/13 · PDP v6 anatomy 9/2
   (Braeden-approved mockup: closeout-mockup/pdp-redesign/pdp-v6-mockup.html).
   One section (sections/ct-pdp.liquid) serves every bare product URL:
   real handles resolve from assets/ct-catalog.json and render client-side
   into the ONE shared ct6-* skeleton (styles: assets/section-ct-pdp6.css)
   that sections/ct-trophy-pdp.liquid also renders server-side — two data
   adapters, one layout contract. Closeout-only modules (price anchor,
   About/PO/tax, schools card) are conditional; data-gated modules render
   nothing when the data is absent. On the 404 template this script doubles
   as the router: legacy /collections/<bucket> URLs redirect to the ?view=
   URLs, unknown paths get the designed not-found state. Depends on
   window.CT (ct-core.js) — loaded synchronously before this deferred
   script. */
(function () {
  'use strict';

  var BUCKET_VIEWS = {
    'Accessories': '/collections/all?view=accessories',
    'Replacement Parts': '/collections/all?view=replacement-parts',
    'Closeout': '/collections/all?view=closeout'
  };
  var COLLECTION_ALIASES = {
    'accessories': 'accessories',
    'replacement-parts': 'replacement-parts',
    'closeout': 'closeout',
    'closeout-deals': 'closeout'
  };

  var PHONE = '864-973-7973';
  var PHONE_HREF = 'tel:8649737973';
  var HOURS = 'Mon–Fri, 8:30–5:30 ET';
  var EMAIL = 'info@getcleartouch.com';

  /* Section-level config (blank-URL dormancy: a blank setting hides its
     link — no dead links, no hardcoded URLs). Read off the section root
     in init(). */
  var CFG = { taxUrl: '', quoteUrl: '', poUrl: '', badgeSrc: '' };

  /* ---------- tiny DOM helper ---------- */
  function h(tag, attrs, kids) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (v === null || v === undefined || v === false) return;
        if (k === 'text') { node.textContent = v; return; }
        node.setAttribute(k, v === true ? '' : String(v));
      });
    }
    (kids || []).forEach(function (kid) {
      if (kid === null || kid === undefined || kid === false) return;
      node.appendChild(typeof kid === 'string' ? document.createTextNode(kid) : kid);
    });
    return node;
  }

  function telLink() { return h('a', { href: PHONE_HREF }, [PHONE]); }

  /* ---------- shared fragments ---------- */

  function mainPlate(p, src) {
    var img = src !== undefined ? src : p.img;
    if (img) {
      return h('div', { 'class': 'ct-plate ct6-lead' }, [
        h('img', { src: img, alt: p.title, 'data-ct6-lead': true })
      ]);
    }
    /* Designed no-image state: part number (or title) set large + hint */
    return h('div', { 'class': 'ct-plate ct-plate--empty ct6-lead' }, [
      h('span', { 'class': 'ct-plate__pn', text: p.sku || p.title }),
      h('span', { 'class': 'ct-plate__hint', text: 'Photo pending' })
    ]);
  }

  function partnoLine(p) {
    if (!p.sku) return null;
    return h('div', { 'class': 'ct-partno' }, [
      h('span', { 'class': 'ct-micro', text: 'Part no.' }),
      h('button', {
        type: 'button',
        'class': 'ct-partno__value ct-num',
        'data-ct-copy': p.sku,
        'aria-label': 'Copy part number ' + p.sku,
        text: p.sku
      })
    ]);
  }

  /* Chips under the title: condition (plain text, no colour), model
     codes, and an honest binary stock state — "In stock" only when a real
     variant is present and available. Never a quantity claim (the store's
     inventory numbers are not credible — 9/2 audit). Disappears entirely
     when there is nothing to say. */
  function chipsRow(p) {
    var chips = [];
    if (p.condition) chips.push(h('span', { 'class': 'ct-chip', text: p.condition }));
    (p.models || []).forEach(function (m) {
      chips.push(h('span', { 'class': 'ct-chip ct-num', text: m }));
    });
    if (p.variantId && p.available) {
      chips.push(h('span', { 'class': 'ct-chip ct6-chip--stock', text: 'In stock' }));
    }
    if (!chips.length) return null;
    return h('div', { 'class': 'ct6-meta' }, chips.concat([partnoLine(p)]).filter(Boolean));
  }

  function atcButton(p) {
    return h('button', {
      type: 'button',
      'class': 'ct-btn ct6-atc',
      'data-ct-atc': true,
      'data-title': p.title,
      'data-variant-id': p.variantId || null
    }, ['Add to cart']);
  }

  function qtyStepper() {
    return h('div', { 'class': 'ct-qty' }, [
      h('button', { type: 'button', 'data-dir': 'down', 'aria-label': 'Decrease quantity' }, ['−']),
      h('input', { type: 'number', value: '1', min: '1', inputmode: 'numeric', 'aria-label': 'Quantity' }),
      h('button', { type: 'button', 'data-dir': 'up', 'aria-label': 'Increase quantity' }, ['+'])
    ]);
  }

  /* Support line — bottom of the info column (moved out of the buy zone,
     v6: nothing between price and Add to cart but the purchase itself). */
  function supportRow() {
    return h('p', { 'class': 'ct6-support' }, [
      'Clear Touch support · ',
      telLink(),
      ' · ' + HOURS + ' · ',
      h('a', { href: 'mailto:' + EMAIL }, [EMAIL])
    ]);
  }

  function nonRefundableNotice() {
    return h('div', { 'class': 'ct-notice' }, [
      'Spare parts orders are non-refundable, and Clear Touch cannot guarantee the ordered part will resolve your issue with your panel. ',
      h('a', { href: PHONE_HREF, text: 'Check fitment with us first.' })
    ]);
  }

  /* Warranty-gated service part (Phase 0, 8/13): reassure first, deter
     second — the buyer was sent this link by Clear Touch Support, and the
     gate is warranty protection via certified install, never a purchase
     restriction. Price and one-click add stay untouched. Neutral gray note,
     never a red banner. NEW COPY — pending client approval. */
  function serviceNote() {
    return h('div', { 'class': 'ct-notice ct6-servicenote' }, [
      h('strong', null, ['This is a service part — if Clear Touch Support sent you this link, you’re in the right place.']),
      ' To keep your panel’s warranty intact, this part is installed by a certified technician with Clear Touch Support guidance.'
    ]);
  }

  function shipLine() {
    return h('p', { 'class': 'ct6-shipline' }, [
      'Shipping & returns: see ',
      h('a', { href: '/policies/shipping-policy' }, ['shipping']),
      ' and ',
      h('a', { href: '/policies/refund-policy' }, ['returns']),
      ' policies.'
    ]);
  }

  /* Verbatim closeout policy line (CONTRACT.md) — every closeout PDP.
     v6: relocated below the dropdown stack (out of the CTA zone), same
     words, quiet register. */
  function policyLine() {
    return h('p', { 'class': 'ct6-policy' }, [
      'Closeout stock is what is on hand and nothing more — once a unit sells, it is gone.'
    ]);
  }

  /* Warranty label ruling (Jenn 8/31, CDXMT-4): ONE label everywhere.
     ⚠️ This string is the client-side twin of snippets/ct-warranty-label.liquid.
     That snippet is the single flip-point for the Liquid surfaces; this is the
     one file that must be changed alongside it. */
  var WARRANTY_LABEL = 'standard warranty';

  function warrantyLine(closeout) {
    return h('p', null, [
      (closeout ? 'Every closeout unit carries the Clear Touch ' : 'Covered by the Clear Touch ')
        + WARRANTY_LABEL + ' — exact terms stated before checkout. Call ',
      telLink(),
      ' with questions.'
    ]);
  }

  /* ---------- spec chip grid (v6) ----------
     Cells come ONLY from the curated `chips` field baked into the catalog
     (body-copy-backed, per-unit). No data → no grid; never padded. Glyphs
     are UI chrome (geometric strokes), not product art. */
  var GLYPHS = {
    panel: '<rect x="3" y="4" width="18" height="13" rx="1.5"/><path d="M12 17v3M8 20h8"/>',
    lift: '<path d="M12 4v16M8.5 7.5 12 4l3.5 3.5M8.5 16.5 12 20l3.5-3.5"/>',
    bundle: '<path d="M3 8.2 12 3l9 5.2v7.6L12 21l-9-5.2zM12 12.4 21 8.2M12 12.4 3 8.2M12 12.4V21"/>',
    doc: '<path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4M9 12h6M9 16h6"/>'
  };
  function chipGrid(p) {
    var cells = (p.chips || []).filter(function (c) { return c && c.label; });
    if (!cells.length) return null;
    return h('div', { 'class': 'ct6-chipgrid' }, cells.map(function (c) {
      var cell = h('div', { 'class': 'ct6-chipcell' });
      if (GLYPHS[c.icon]) {
        var g = h('span', { 'class': 'ct6-glyph', 'aria-hidden': 'true' });
        g.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + GLYPHS[c.icon] + '</svg>';
        cell.appendChild(g);
      }
      cell.appendChild(h('span', { text: c.label }));
      return cell;
    }));
  }

  /* ---------- dropdown stack ---------- */
  function accItem(label, kids, open) {
    return h('details', open ? { open: true } : null,
      [h('summary', null, [label])].concat(kids || []));
  }

  /* Spec rows for the "Specifications" dropdown — the single spec surface,
     SKU/part number inside it (Jenn 8/19, round 5). */
  function specTable(p) {
    var rows = [];
    if (p.sku) rows.push(['Part number', p.sku]);
    if (p.models && p.models.length) rows.push(['Fits models', p.models.join(', ')]);
    if (p.pack && p.pack.label) rows.push(['Ships as', p.pack.label.replace(/^Ships as /, '')]);
    /* 'Ordered last 12 months' row removed (mobile polish 9/29): low counts
       read as anti-proof. orders12 still feeds search ranking in ct-core. */
    if (!rows.length) return null;
    return h('div', { 'class': 'ct6-specwrap' }, [
      h('table', { 'class': 'ct-spec' }, [
        h('tbody', null, rows.map(function (r) {
          return h('tr', null, [
            h('th', { scope: 'row', text: r[0] }),
            h('td', { 'class': 'ct-num', text: r[1] })
          ]);
        }))
      ])
    ]);
  }

  /* Closeout body split — same rule the trophy adapter runs in Liquid:
     everything before the first '<h4>Specification' is Description prose,
     the tail (minus that heading) renders inside Specifications. */
  function splitBody(html) {
    var out = { prose: html || '', specs: '' };
    var i = (html || '').indexOf('<h4>Specification');
    if (i !== -1) {
      var tail = html.slice(i);
      var close = tail.indexOf('</h4>');
      if (close !== -1) {
        out.prose = html.slice(0, i);
        out.specs = tail.slice(close + 5);
      }
    }
    return out;
  }
  function textOf(htmlStr) {
    var d = document.createElement('div');
    d.innerHTML = htmlStr || '';
    return (d.textContent || '').replace(/\s+/g, ' ').trim();
  }
  /* Intro text must not swallow section headings ("Details When sold
     together…") — drop heading blocks before flattening. */
  function introTextOf(htmlStr) {
    return textOf(String(htmlStr || '').replace(/<h[1-6][^>]*>[\s\S]*?<\/h[1-6]>/gi, ' '));
  }
  /* Closeout money register matches the trophy adapter: whole-dollar
     amounts render without cents ($4,999, never $4,999.00). */
  function moneyUnit(n) {
    return (Number(n) % 1 === 0) ? window.CT.moneyShort(n) : window.CT.money(n);
  }

  /* Form-first PO/tax dropdown (closeout) — verbatim trophy copy; links
     reuse the section's tax/quote seams and hide individually while blank. */
  function poTaxItem(shipsDays) {
    var kids = [
      h('p', null, ['Schools and districts: purchase orders and tax-exempt purchasing both work here — start online and we’ll take it from there.'])
    ];
    var links = [];
    if (CFG.taxUrl) links.push(h('a', { href: CFG.taxUrl }, ['Tax-exempt setup →']));
    if (CFG.quoteUrl) links.push(h('a', { href: CFG.quoteUrl }, ['Request a quote →']));
    if (links.length) kids.push(h('p', { 'class': 'ct6-instlinks' }, links));
    kids.push(h('p', null, [
      'Prefer to talk? Call ', telLink(),
      ' (' + HOURS + '). Freight is quoted before you’re charged, and we coordinate delivery with your dock or front office.'
    ]));
    return accItem('PO, tax-exempt & freight', kids);
  }

  /* Schools & districts card — the colour callout, below the dropdowns
     (v6 relocation out of the CTA zone). Hides when both links are blank. */
  function schoolsCard() {
    if (!CFG.poUrl && !CFG.taxUrl) return null;
    var links = [];
    if (CFG.poUrl) links.push(h('a', { href: CFG.poUrl }, ['How purchase orders work →']));
    if (CFG.taxUrl) links.push(h('a', { href: CFG.taxUrl }, ['Tax-exempt setup →']));
    return h('div', { 'class': 'ct6-inst' }, [
      h('b', null, ['Buying for a school or district?']),
      h('span', null, ['Purchase orders and tax-exempt purchasing both work here.']),
      h('span', { 'class': 'ct6-instlinks' }, links)
    ]);
  }

  /* Tax-exempt card — every non-closeout PDP (accessories + parts), same
     colour callout as the schools card. Closeout PDPs keep the schools card
     instead. Hides while the tax link is blank. Jenn 10/21: closeout gets
     1-2 tax-exempt questions a day. NEW COPY — pending client approval. */
  function taxCard() {
    if (!CFG.taxUrl) return null;
    return h('div', { 'class': 'ct6-inst' }, [
      h('b', null, ['Buying tax-exempt?']),
      h('span', null, ['Upload your exemption certificate once. After it’s approved, your orders check out tax-free.']),
      h('span', { 'class': 'ct6-instlinks' }, [h('a', { href: CFG.taxUrl }, ['Tax-exempt setup →'])])
    ]);
  }

  /* Trust row — the store's own published claims (brand sheet), real badge
     asset from the section, pink micro-tick on the eyebrow only. */
  function trustRow() {
    var text = h('div', { 'class': 'ct6-trust__text' }, [
      h('span', { 'class': 'ct-micro ct6-trust__kicker', text: 'Buy direct from Clear Touch' }),
      h('span', { 'class': 'ct6-trust__line', text: 'U.S. Owned & Operated — headquartered in Greenville, South Carolina. 94.5% of support calls answered live.' })
    ]);
    var row = h('div', { 'class': 'ct6-trust' }, [text]);
    if (CFG.badgeSrc) {
      row.appendChild(h('img', {
        'class': 'ct6-trust__badge',
        src: CFG.badgeSrc,
        alt: 'UL, EDLA and Android certification badges',
        loading: 'lazy'
      }));
    }
    return row;
  }

  /* ---------- fitment -- three states, never two ---------- */
  function fitBlock(p, data) {
    var wrap = h('div', { 'class': 'ct-fit' });
    var select = h('select', { 'aria-label': 'Your panel or PC module' });
    select.appendChild(h('option', { value: '', text: 'Select your model…' }));
    var placed = {};
    (data.families || []).forEach(function (fam) {
      var codes = (fam.codes || []).filter(function (c) {
        return (data.models || []).indexOf(c) !== -1;
      });
      if (!codes.length) return;
      var og = h('optgroup', { label: fam.name });
      codes.forEach(function (c) {
        placed[c] = true;
        og.appendChild(h('option', { value: c, text: c }));
      });
      select.appendChild(og);
    });
    var leftovers = (data.models || []).filter(function (m) { return !placed[m]; });
    if (leftovers.length) {
      var og2 = h('optgroup', { label: 'Other' });
      leftovers.forEach(function (m) { og2.appendChild(h('option', { value: m, text: m })); });
      select.appendChild(og2);
    }

    var verdict = h('span', { 'class': 'ct-fit__verdict' });
    var detail = h('span', { 'class': 'ct-fit__detail' });
    var answer = h('div', { 'class': 'ct-fit__answer' }, [verdict, detail]);
    var hint = h('div', {
      'class': 'ct-fit__list ct-pdp-fit-hint',
      text: 'Pick your model to check fit before you order.'
    });
    var list = (p.models && p.models.length)
      ? h('div', { 'class': 'ct-fit__list', text: 'Fits: ' + p.models.join(', ') })
      : null;

    function apply(model) {
      var state = window.CT.fitState(p.models, model);
      wrap.classList.remove('ct-fit--yes', 'ct-fit--maybe', 'ct-fit--no');
      answer.classList.toggle('is-on', state !== 'unset');
      hint.hidden = state !== 'unset';
      while (detail.firstChild) detail.removeChild(detail.firstChild);
      if (state === 'yes') {
        wrap.classList.add('ct-fit--yes');
        verdict.textContent = 'This fits';
        detail.textContent = 'Listed for ' + model + ' in Clear Touch’s own fit data.';
      } else if (state === 'maybe') {
        wrap.classList.add('ct-fit--maybe');
        verdict.textContent = 'This might fit';
        detail.appendChild(document.createTextNode('We haven’t published fit data for this part. Call '));
        detail.appendChild(telLink());
        detail.appendChild(document.createTextNode(' before you order.'));
      } else if (state === 'no') {
        wrap.classList.add('ct-fit--no');
        verdict.textContent = 'This does not fit ' + model;
        detail.textContent = 'Buildings often run mixed fleets — check the label on the module you’re repairing.';
      } else {
        verdict.textContent = '';
      }
    }

    select.addEventListener('change', function () {
      window.CT.setMyModel(select.value);
      apply(select.value);
    });

    var saved = window.CT.getMyModel();
    if (saved) select.value = saved; /* stays '' if the option doesn't exist */
    apply(select.value || '');

    wrap.appendChild(h('div', { 'class': 'ct-micro ct-fit__label', text: 'Your panel or PC module' }));
    wrap.appendChild(h('div', { 'class': 'ct-fit__row' }, [select]));
    wrap.appendChild(answer);
    if (list) wrap.appendChild(list);
    wrap.appendChild(hint);
    return wrap;
  }

  /* ---------- complementary -- max 2 compact cards, skip missing ---------- */
  function compCard(t) {
    var plate = h('span', { 'class': 'ct-plate' + (t.img ? '' : ' ct-plate--empty') });
    if (t.img) plate.appendChild(h('img', { src: t.img, alt: t.title, loading: 'lazy' }));
    else plate.appendChild(h('span', { 'class': 'ct-plate__pn', text: t.sku || t.title }));
    return h('div', { 'class': 'ct-pdp-compcard', 'data-ct-atc-scope': true }, [
      h('a', { 'class': 'ct-pdp-compcard__link', href: '/products/' + t.handle }, [
        plate,
        h('span', { 'class': 'ct-pdp-compcard__text' }, [
          h('span', { 'class': 'ct-pdp-compcard__title', text: t.title }),
          t.sku ? h('span', { 'class': 'ct-pdp-compcard__pn ct-num', text: t.sku }) : null
        ])
      ]),
      h('span', { 'class': 'ct-pdp-compcard__price ct-num', text: window.CT.money(t.price) }),
      h('button', {
        type: 'button',
        'class': 'ct-btn ct-btn--sm',
        'data-ct-atc': true,
        'data-title': t.title,
        'data-variant-id': t.variantId || null,
        'aria-label': 'Add ' + t.title + ' to cart'
      }, ['Add'])
    ]);
  }

  function compBlock(p, data) {
    var cards = [];
    (p.complementary || []).forEach(function (handle) {
      if (cards.length >= 2) return;
      var t = data.byHandle[handle];
      if (!t) return;
      cards.push(compCard(t));
    });
    if (!cards.length) return null;
    var heading = p.bucket === 'Closeout' ? 'Add what’s not in the box'
      : p.bucket === 'Accessories' ? 'Often ordered together'
        : 'Also needed for this repair';
    var wrap = h('div', { 'class': 'ct-pdp-comp' }, [
      h('span', { 'class': 'ct-micro ct-pdp-mh', text: heading })
    ]);
    cards.forEach(function (c) { wrap.appendChild(c); });
    return wrap;
  }

  /* ---------- sticky mobile ATC ---------- */
  function stickyBar(p, mainBtn) {
    if (!mainBtn || !('IntersectionObserver' in window)) return;
    if (document.querySelector('.ct-pdp-sticky')) return; /* idempotent */
    var goBtn = h('button', { type: 'button', 'class': 'ct-btn ct-btn--accent' }, ['Add to cart']);
    goBtn.addEventListener('click', function () { mainBtn.click(); });
    var bar = h('div', { 'class': 'ct-pdp-sticky' }, [
      h('div', { 'class': 'ct-pdp-sticky__info' }, [
        h('span', { 'class': 'ct-pdp-sticky__price ct-num', text: window.CT.money(p.price) }),
        p.sku ? h('span', { 'class': 'ct-pdp-sticky__sku ct-num', text: p.sku }) : null
      ]),
      goBtn
    ]);
    document.body.appendChild(bar);
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (!e) return;
      /* only once the buy button has scrolled up out of view -- not while it
         is still below the fold on load */
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(mainBtn);
  }

  /* ---------- media column ---------- */
  function mediaCol(p, closeout) {
    var col = h('div', { 'class': 'ct6-media' });
    var images = closeout
      ? ((p.images && p.images.length) ? p.images : (p.img ? [p.img] : []))
      : (p.img ? [p.img] : []);
    var lead = mainPlate(p, images[0] || '');
    /* Save badge on the plate — money only, real compare-at only */
    if (closeout && p.compareAt && p.compareAt > p.price) {
      lead.insertBefore(
        h('span', { 'class': 'ct-badge ct-num', text: 'Save ' + window.CT.moneyFloor(p.compareAt - p.price) }),
        lead.firstChild
      );
    }
    col.appendChild(lead);
    var leadImg = lead.querySelector('img');
    if (images.length > 1) {
      var rail = h('div', { 'class': 'ct6-thumbs' });
      images.forEach(function (src, i) {
        var b = h('button', {
          type: 'button',
          'class': 'ct6-thumb' + (i === 0 ? ' is-active' : ''),
          'aria-label': 'Show image ' + (i + 1) + ' of ' + images.length
        }, [
          h('span', { 'class': 'ct-plate' }, [h('img', { src: src, alt: '', loading: 'lazy' })])
        ]);
        b.addEventListener('click', function () {
          if (leadImg) leadImg.src = src;
          var act = rail.querySelector('.is-active');
          if (act) act.classList.remove('is-active');
          b.classList.add('is-active');
        });
        rail.appendChild(b);
      });
      col.appendChild(rail);
    }
    if (closeout && images.length) {
      /* Verbatim gallery line (CONTRACT.md) — every closeout PDP with
         photography, whether or not a condition marker exists. */
      col.appendChild(h('p', {
        'class': 'ct6-galnote',
        text: 'Photography shows the model. Cosmetic condition is described below.'
      }));
    }
    return col;
  }

  /* ---------- the ONE v6 renderer (both product kinds) ---------- */
  function renderV6(p, data, mount) {
    var closeout = p.bucket === 'Closeout';
    var col = h('div', { 'class': 'ct6-col' });

    /* orientation first on gated service parts */
    if (p.service) col.appendChild(serviceNote());

    col.appendChild(h('h1', { 'class': 'ct6-h1', text: p.title }));
    var meta = chipsRow(p) || (partnoLine(p) ? h('div', { 'class': 'ct6-meta' }, [partnoLine(p)]) : null);
    if (meta) col.appendChild(meta);

    if (closeout && p.condition) {
      col.appendChild(h('p', {
        'class': 'ct6-cond',
        text: 'Condition: ' + p.condition + ' — sold as-is, described below.'
      }));
    }

    /* Short description renders ONCE, inline under the title; long copy
       gets the Description dropdown instead (Jenn 8/19: "Repetitive"). */
    var descDropdownHtml = null; /* HTML string for closeout, text for lean */
    if (closeout) {
      var body = splitBody(p.body || '');
      var proseText = introTextOf(body.prose);
      if (proseText) {
        if (proseText.length <= 240) {
          col.appendChild(h('p', { 'class': 'ct6-intro', text: proseText }));
        } else {
          var first = proseText.split('. ')[0];
          if (first && first.length <= 220) {
            col.appendChild(h('p', { 'class': 'ct6-intro', text: first + '.' }));
          }
          descDropdownHtml = body.prose;
        }
      }
      p._specsTail = body.specs; /* consumed by the accordion below */
    } else if (p.desc) {
      if (p.desc.length <= 240) {
        col.appendChild(h('p', { 'class': 'ct6-intro', text: p.desc }));
      } else {
        descDropdownHtml = p.desc; /* plain text */
      }
    }

    /* price block */
    var price = h('div', { 'class': 'ct6-price' });
    if (closeout) price.appendChild(h('span', { 'class': 'ct-micro', text: 'Closeout price' }));
    var row = h('div', { 'class': 'ct6-price__row' });
    if (closeout && p.compareAt && p.compareAt > p.price) {
      /* v4 register: labeled anchor + dollars-only floored save; used-unit
         contract (8/19): condition === 'Used' → "Sold at". */
      row.appendChild(h('span', { 'class': 'ct6-now ct-num is-sale', text: moneyUnit(p.price) }));
      row.appendChild(h('span', { 'class': 'ct6-price__stack' }, [
        h('span', { 'class': 'ct6-was ct-num' }, [
          p.condition === 'Used' ? 'Sold at ' : 'Sold new at ',
          h('s', null, [moneyUnit(p.compareAt)])
        ]),
        h('span', { 'class': 'ct6-save ct-num', text: 'You save ' + window.CT.moneyFloor(p.compareAt - p.price) })
      ]));
    } else {
      row.appendChild(h('span', { 'class': 'ct6-now ct-num', text: closeout ? moneyUnit(p.price) : window.CT.money(p.price) }));
      if (p.pack && p.pack.perUnit) {
        row.appendChild(h('span', { 'class': 'ct6-perunit ct-num', text: window.CT.money(p.pack.perUnit) + ' per ' + p.pack.unit }));
      }
    }
    if (p.note) row.appendChild(h('span', { 'class': 'ct6-note', text: p.note }));
    price.appendChild(row);
    if (closeout) {
      /* freight reassurance — CD's "shipping calculated" slot (trophy
         freight_line default; one quiet line, not buy-zone clutter) */
      price.appendChild(h('div', { 'class': 'ct6-price__quiet', text: 'Freight is quoted before you’re charged' }));
    }
    col.appendChild(price);

    /* fitment (purchase-completing) — parts + accessories */
    /* Mobile polish 9/29: no fit data at all (cables, universal items) →
       no checker. A box that can only ever answer "might fit" alarms more
       than it helps. */
    if (!closeout && p.models && p.models.length) col.appendChild(fitBlock(p, data));

    /* buy zone */
    var atc = null;
    var buy = h('div', { 'class': 'ct6-buy' });
    if (!p.available) {
      /* end state -- one and done */
      buy.appendChild(h('div', { 'class': 'ct-notice' }, [
        'This unit has sold. Closeout stock is one and done — tell us what you’re looking for: ',
        telLink(),
        '.'
      ]));
    } else {
      if (!closeout) {
        buy.appendChild(h('div', { 'class': 'ct6-qtyline' }, [
          qtyStepper(),
          (p.pack && p.pack.label) ? h('span', { 'class': 'ct-micro ct6-packlabel', text: p.pack.label }) : null
        ]));
      }
      atc = atcButton(p); /* closeout units: single, no stepper */
      buy.appendChild(atc);
      if (closeout) {
        buy.appendChild(CFG.quoteUrl
          ? h('a', { 'class': 'ct6-bulk', href: CFG.quoteUrl }, ['Buying in bulk? Request a quote'])
          : h('span', { 'class': 'ct6-bulk' }, ['Buying in bulk? Call ', telLink(), ' for a quote']));
      }
    }
    buy.setAttribute('data-ct-atc-scope', '');
    col.appendChild(buy);

    /* pre-purchase warning stays adjacent to the buy row (phase-2 §2.3) */
    if (p.bucket === 'Replacement Parts') col.appendChild(nonRefundableNotice());

    var grid = chipGrid(p);
    if (grid) col.appendChild(grid);

    /* dropdown stack — first renders open; empty data renders no dropdown.
       id = deep-link target (unique — one PDP per page). */
    var acc = h('div', { 'class': 'ct6-acc', id: 'ct-pdp-details' });
    var first = true;
    function add(label, kids) {
      acc.appendChild(accItem(label, kids, first));
      first = false;
    }
    if (descDropdownHtml) {
      if (closeout) {
        var bodyEl = h('div', { 'class': 'ct6-bodyhtml' });
        bodyEl.innerHTML = descDropdownHtml; /* store-authored HTML from the catalog build */
        add('Description', [bodyEl]);
      } else {
        add('Description', [h('p', { text: descDropdownHtml })]);
      }
    }
    if (p.included) add('What’s included', [h('p', { text: p.included })]);
    var spec = specTable(p);
    var specKids = spec ? [spec] : [];
    if (closeout && p._specsTail) {
      var tailEl = h('div', { 'class': 'ct6-bodyhtml ct6-specdesc' });
      tailEl.innerHTML = p._specsTail; /* real spec-sheet/manual links + tables */
      specKids.push(tailEl);
    }
    if (specKids.length) add('Specifications', specKids);
    add('Warranty', closeout ? [warrantyLine(true)] : [warrantyLine(false), shipLine()]);
    if (closeout) acc.appendChild(poTaxItem());
    col.appendChild(acc);

    /* relocated closeout modules (out of the CTA zone) */
    if (closeout) {
      col.appendChild(policyLine());
      var inst = schoolsCard();
      if (inst) col.appendChild(inst);
    } else {
      var tax = taxCard();
      if (tax) col.appendChild(tax);
    }

    col.appendChild(trustRow());
    col.appendChild(supportRow());

    /* under-gallery column: complementary rows only */
    var below = h('div', { 'class': 'ct6-below' });
    var comp = compBlock(p, data);
    if (comp) below.appendChild(comp);

    mount.innerHTML = '';
    mount.appendChild(h('div', { 'class': 'ct6-grid' }, [
      mediaCol(p, closeout),
      col,
      below.childNodes.length ? below : null
    ]));

    if (atc) stickyBar(p, atc);
  }

  /* ---------- crumbs / not-found / pdp flow ---------- */

  function renderCrumbs(root, p) {
    var mount = root.querySelector('[data-ct-crumbs]');
    if (!mount) return;
    function sep() {
      return h('span', { 'class': 'ct-pdp-crumbs__sep', 'aria-hidden': 'true', text: '›' });
    }
    mount.innerHTML = '';
    mount.appendChild(h('a', { href: '/' }, ['Home']));
    mount.appendChild(sep());
    if (BUCKET_VIEWS[p.bucket]) {
      mount.appendChild(h('a', { href: BUCKET_VIEWS[p.bucket] }, [p.bucket]));
      mount.appendChild(sep());
    }
    mount.appendChild(h('span', { 'class': 'ct-pdp-crumbs__here', 'aria-current': 'page', text: p.title }));
  }

  function showNotFound(root) {
    var body = root.querySelector('[data-ct-pdp-body]');
    if (body) body.innerHTML = '';
    var crumbs = root.querySelector('[data-ct-crumbs]');
    if (crumbs) crumbs.hidden = true;
    var nf = root.querySelector('[data-ct-notfound]');
    if (nf) nf.hidden = false;
  }

  function renderPdp(root, handle) {
    var hasSSR = !!root.querySelector('[data-ct-pdp-body] .ct6-grid');
    window.CT.catalog().then(function (data) {
      /* Gated (direct-link-only) parts resolve here and ONLY here — the
         router is the one surface allowed to read gatedByHandle. */
      var p = data.byHandle[handle] || (data.gatedByHandle || {})[handle];
      if (!p) { showNotFound(root); return; }
      var mount = root.querySelector('[data-ct-pdp-body]');
      if (!mount) return;
      document.title = p.title + ' — Clear Touch';
      renderCrumbs(root, p);
      renderV6(p, data, mount);
      /* The details column renders after native fragment navigation has
         already given up — honour a #ct-pdp-details deep link ourselves. */
      if (location.hash === '#ct-pdp-details') {
        var target = document.getElementById('ct-pdp-details');
        if (target) target.scrollIntoView();
      }
    }).catch(function () {
      /* catalog unreachable: keep the server-rendered block for the live
         products; otherwise fall back to the designed not-found state */
      if (!hasSSR) showNotFound(root);
    });
  }

  /* ---------- router ---------- */
  function route(root) {
    var attr = root.getAttribute('data-handle');
    if (attr) { renderPdp(root, attr); return; }

    var path = (location.pathname || '/').replace(/\/+$/, '') || '/';

    var pm = path.match(/\/products\/([^\/?#]+)/);
    if (pm) { renderPdp(root, decodeURIComponent(pm[1])); return; }

    var cm = path.match(/^\/collections\/([^\/]+)$/);
    if (cm) {
      var seg = decodeURIComponent(cm[1]).toLowerCase();
      var view = COLLECTION_ALIASES[seg];
      if (view) {
        /* alias → canonical view URL, keeping any query string extras */
        var params = new URLSearchParams(location.search);
        params.set('view', view);
        location.replace('/collections/all?' + params.toString());
        return;
      }
      showNotFound(root);
      return;
    }

    showNotFound(root);
  }

  function init() {
    if (!window.CT || typeof window.CT.catalog !== 'function') return;
    var root = document.querySelector('[data-ct-pdp]');
    if (!root || root.hasAttribute('data-ct-pdp-init')) return;
    root.setAttribute('data-ct-pdp-init', '');
    CFG.taxUrl = root.getAttribute('data-tax-url') || '';
    CFG.quoteUrl = root.getAttribute('data-quote-url') || '';
    CFG.poUrl = root.getAttribute('data-po-url') || '';
    CFG.badgeSrc = root.getAttribute('data-badge-src') || '';
    route(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
